import { RecursiveCSS } from "../theme/GlobalTheme";
import { Box } from "../box/Box";
import { useWindowSize } from "../utils/useResize";
import { Section } from "./Section";
import React from "react";

interface IPageProps {
	children?: React.ReactNode;
	rightSection?: React.ReactNode;
	label?: string;
	description?: string;
	sectionRightContent?: React.ReactNode;
	onBack?: () => void;
	disableScroll?: boolean;
	separatePanelsScroll?: boolean;
	sx?: RecursiveCSS;
}

export const Page = (props: IPageProps) => {
	const size = useWindowSize();
	const isMobile = size.width <= 768;
	let fullsize = false;
	if (size.width < 1540) fullsize = true;

	const rightPanelNode = props.rightSection && React.isValidElement(props.rightSection) ? props.rightSection : null;
	const rightPanelProps = rightPanelNode ? (rightPanelNode.props as any) : {};

	const showRightSidePanel = !fullsize && !isMobile && props.rightSection;
	let showRightBelow = fullsize && !isMobile && props.rightSection;

	//!TODO: need to show in any case?
	showRightBelow = false;

	return (
		<Box
			sx={{
				display: "grid",
				gridTemplateColumns: showRightSidePanel
					? `minmax(0,73fr) ${rightPanelProps.sx?.maxWidth ? rightPanelProps.sx.maxWidth : "minmax(350px,27fr)"}`
					: "minmax(0, 1fr)",
				gap: "16px",
				minHeight: showRightBelow ? "auto" : "100%",
				minWidth: "0px",
			}}>
			<Section
				sx={{
					...(props.disableScroll ? { height: "100%" } : {}),
					...(props.separatePanelsScroll ? { overflow: "auto", minHeight: "0px" } : {}),
					padding: isMobile ? "14px" : "28px",
					...props.sx,
				}}
				label={props.label}
				description={props.description}
				rightZone={props.sectionRightContent}>
				{props.children}
			</Section>
			{showRightSidePanel && (
				<Box sx={{ height: "100%", minHeight: "0px", ...(props.separatePanelsScroll ? { overflow: "auto" } : {}) }}>{props.rightSection}</Box>
			)}
			{showRightBelow && <Box sx={{ minHeight: "0px" }}>{props.rightSection}</Box>}
		</Box>
	);
};
